export default {
  linkAccount: 'Link Account',
  inputPhone: 'Enter Mobile Number',
  bindLogin: 'Link & Login',
  loginAction: 'Login',
  registerAction: 'Register',
  registerNow: 'Register Now',
  contactInput: 'Enter Mobile Number or Email',
  verificationCodeInput: 'Enter Verification Code',
  loginRegister: 'Login / Register',
  agreementCheck1: 'I have read and agree to the ',
  agreementCheck2: 'Third-party Service Agreement',
  getCode: 'Get Code',
  codeInputPrompt: 'Enter Your Verification Code',
  agreementPrompt: 'Please read and check the Service Agreement',
  validContactPrompt: 'Enter a valid mobile number or email',
  retryCountdown: 'Retry in seconds',
  frequentContactInput: 'Enter your frequently used mobile/email',
  passwordInput: 'Enter Password',
  passwordPrompt: 'Enter Your Password',
  expiredRefresh: 'Expired. Click to refresh',
  qrScanPrompt: 'Scan QR Code to Follow',
  instantAccess: 'Login/Register Instantly',
  autoRegistration: 'First-time scanning will auto-register a new account',
  forgotPassword: 'Forgot Password',
  newPasswordInput: 'Enter New Password',
  resetPasswordAction: 'Reset Password',
  accountNotRegistered: 'This mobile number or email is not registered',
  invalidParameters: 'Invalid Parameters',
  wechatLogin: 'WeChat QR Code Login/Registration',
  smsLogin: 'Mobile/Email Code Login',
  passwordLogin: 'Password Login',
  accountLoginOption: 'Account Login',
  qrLoginOption: 'QR Code Login'
}
